export default {
  "version": "{{VERSION}}",
  "search": {
    "quickLinks": {
      "defaultValue": [
        {
          "text": "EXCLUSIVE",
          "linkId": "exclusive888arenaLink"
        },
        {
          "text": "PROMOTIONS",
          "linkId": "promotionsLink"
        },
        {
          "text": "CASHIER",
          "menuItemKey": "depositMenuItem"
        }
      ]
    },
    "suggestedGames": {
      "defaultValue": [
        130191,
        130043,
        2370000,
        2310404,
        2340099,
        2341097
      ]
    },
    "suggestedCategories": {
      "defaultSuggestedCategories": {
        "defaultValue": [
          {
            "text": "Exklusive Spiele",
            "linkId": "exclusive888arenaLink"
          },
          {
            "text": "Promotions",
            "linkId": "promotionsLink"
          },
          {
            "text": "Cashier",
            "menuItemKey": "depositMenuItem"
          }
        ]
      },
      "suggestedCategoriesOptions": {
        "defaultValue": []
      }
    }
  },
  "ClockAndLastLoginBox": {
    "lastLoginDisplay": {
      "defaultValue": false,
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": true
            }
          ],
          "value": true
        }
      ]
    },
    "display": true
  },
  "header": {
    "gambling_message": {
      "display": false
    },
    "responsibleIcons": {
      "position": "topHeaderRight",
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": true
          }
        ]
      }
    },
    "header_buttons": {
      "deposit": true,
      "safezoneButton": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "deviceType",
                  "operator": "equal",
                  "value": "mobile"
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": false
                }
              ],
              "value": false
            }
          ]
        }
      }
    },
    "cross_brand": []
  },
  "links": {
    "newGamesLink": "/neue-slots/",
    "exclusive888arenaLink": "/exklusive-spiele/",
    "scratchCardsLink": "/rubbellose/",
    "blogLink": {
      "url": "/blog/",
      "openMode": "newTab",
      "shouldAppendSCutToUrl": true
    },
    "responsibleGamingLink": {
      "url": "https://www.mrgreen.de/greengaming"
    },
    "mobileAppsLink": "/mrgreen-apps-ios-android/"
  },
  "menuItems": {
    "signUpMenuItem": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": true
          }
        ]
      }
    },
    "blogMenuItem": {
      "display": {
        "defaultValue": true,
        "statements": [
          {
            "condition": "OR",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": false
          }
        ]
      }
    },
    "chatMenuItem": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "_IsChatEligible",
                "operator": "equal",
                "value": true
              }
            ],
            "value": true
          }
        ]
      }
    },
    "mobileAppsMenuItem": {
      "text": "App"
    }
  },
  "bottomNavigationBar": {
    "menuItemsOrder": [
      "homeMenuItem",
      "slotsMenuItem",
      "exclusive888arenaMenuItem",
      "promotionsMenuItem",
      "depositMenuItem"
    ]
  },
  "sideMenu": {
    "menuLinksBlockOrder": {
      "defaultValue": [
        [
          "signUpMenuItem"
        ],
        [
          "promotionsMenuItem"
        ],
        [
          "homeMenuItem",
          "slotsMenuItem",
          "newGamesMenuItem",
          "exclusive888arenaMenuItem"
        ],
        [
          "mobileAppsMenuItem",
          "blogMenuItem"
        ],
        [
          "chatMenuItem"
        ]
      ]
    },
    "store_button": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              },
              {
                "id": "isHybrid",
                "operator": "equal",
                "value": false
              },
              {
                "condition": "OR",
                "rules": [
                  {
                    "id": "countryCode",
                    "operator": "equal",
                    "value": "dan"
                  }
                ]
              }
            ],
            "value": true
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              },
              {
                "id": "isHybrid",
                "operator": "equal",
                "value": false
              },
              {
                "condition": "OR",
                "rules": [
                  {
                    "id": "countryCode",
                    "operator": "equal",
                    "value": "gbr"
                  }
                ]
              }
            ],
            "value": false
          }
        ]
      },
      "imgSrcFallback": {
        "defaultValue": "",
        "statements": [
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              }
            ],
            "value": "{assetsPath}/images/store/store-button-ios-eng.svg"
          },
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              }
            ],
            "value": "{assetsPath}/images/store/store-button-android-eng.png"
          }
        ]
      },
      "imgSrc": {
        "defaultValue": "",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              },
              {
                "id": "langCode",
                "operator": "any_of",
                "value": [
                  "eng",
                  "ger",
                  "swe",
                  "rus",
                  "por",
                  "fre",
                  "spa",
                  "fin",
                  "nor"
                ]
              }
            ],
            "value": "{assetsPath}/images/store/store-button-ios-{lang}.svg"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              },
              {
                "id": "langCode",
                "operator": "any_of",
                "value": [
                  "eng",
                  "ger",
                  "swe",
                  "rus",
                  "por",
                  "fre",
                  "spa",
                  "fin",
                  "nor"
                ]
              }
            ],
            "value": "{assetsPath}/images/store/store-button-android-{lang}.png"
          }
        ]
      },
      "appLink": {
        "defaultValue": "",
        "statements": [
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "ios"
              }
            ],
            "value": "https://app.appsflyer.com/id998457567"
          },
          {
            "rules": [
              {
                "id": "operationSystem",
                "operator": "equal",
                "value": "android"
              }
            ],
            "value": "https://play.google.com/store/apps/details?id=com.r888.rl"
          }
        ]
      }
    },
    "helpLinkMobile": {
      "display": true
    }
  },
  "drawer": {
    "welcomeMessage": {
      "conditions": [
        {
          "time": "00:00",
          "text": "GREETING_MORNING"
        },
        {
          "time": "12:00",
          "text": "GREETING_AFTERNOON"
        },
        {
          "time": "18:00",
          "text": "GREETING_EVENING"
        },
        {
          "time": "22:00",
          "text": "GREETING_NIGHT"
        }
      ],
      "defaultMessage": "GREETING_DEFAULT",
      "showUserTitle": false,
      "showFirstName": true,
      "showLastName": false
    },
    "usefulLinks": [
      [
        {
          "menuItemKey": "historyMenuItem",
          "subItems": [
            "gamingHistoryMenuItem",
            "transactionHistoryMenuItem",
          ]
        },
        "touchIdMenuItem",
        "aboutDialogMenuItem",
        "hybridInfoMenuItem"
      ], [
        "helpCenterMenuItem",
      ]
    ],
    "showLoyalty": {
      "display": {
        "defaultValue": false,
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              },
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              },
              {
                "id": "_IsCIP",
                "operator": "equal",
                "value": true
              }
            ],
            "value": true
          }
        ]
      }
    }
  },
  "gamePopup": {
    "title": "GAME_POPUP_TITLE",
    "subTitle": "GAME_POPUP_SUB_TITLE",
    "descriptionText": "GAME_POPUP_DESCRIPTION",
    "menuLinks": [
      "gamingHistory",
      "cashierHistory"
    ]
  },
  "footer": {
    "componentID": {
      "defaultValue": "575329",
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "isEmbeddedHybrid",
              "operator": "equal",
              "value": true
            }
          ],
          "value": "576031"
        }
      ]
    },
    "templateID": {
      "defaultValue": "392012"
    },
    "fallbackComponent": "defaultFooter"
  },
  "arenas": {
    "slots": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/slots_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "pc"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_pc.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/slots_arena_banner_mobile.png"
          }
        ]
      },
      "animatedTopImage": {
        "url": {
          "defaultValue": "{assetsPath}/images/animated-banners/slots_arena_banner_pc.lottie",
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "mAndBelow",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": "{assetsPath}/images/animated-banners/slots_arena_banner_mobile.lottie"
            }
          ]
        }
      },
      "title": {
        "defaultValue": "INFO_TITLE_ARENA_VIDEO_SLOTS",
        "statements": []
      },
      "filters": {
        "defaultValue": [
          "vendor_888",
          "vendor_playngo",
          "vendor_merkur",
          "vendor_gamomat",
          "vendor_netent",
          "vendor_redtiger",
          "vendor_pragmatic"
        ],
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "isMobile",
                "operator": "equal",
                "value": true
              }
            ],
            "value": [
              "vendor_888",
              "vendor_netent",
              "vendor_playngo",
              "vendor_pragmatic",
              "vendor_playtech",
              "vendor_redtiger",
              "vendor_merkur",
              "vendor_blueprint",
              "one-to-twenty-five",
              "twenty-five-plus"
            ]
          }
        ]
      },
      "advancedFilters": {
        "categories": [
          {
            "id": "volatility"
          },
          {
            "id": "features"
          },
          {
            "id": "themes"
          },
          {
            "id": "vendors"
          }
        ]
      },
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/slots_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_SLOTS",
        "infoText": "INFO_TEXT_ARENA_SLOTS"
      },
      "promotionalBanner": {
        "bannerAdminPlaceholderId": "4B0F5741-8EF5-466A-A75C-DE98D678FF74"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "495175",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": {
          "defaultValue": "576020"
        },
        "templateID": {
          "defaultValue": "392012"
        }
      },
      "homepageHeader": {
        "title": "SLOTS",
        "image": "{assetsPath}/images/arenas/HomePage/slots_jackpots_arena.png",
        "link": "/slots/"
      }
    },
    "exclusive888Games": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/exclusive_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/exclusive_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/exclusive_arena_banner_mobile.png"
          }
        ]
      },
      "animatedTopImage": {
        "url": {
          "defaultValue": "{assetsPath}/images/animated-banners/exclusive_arena_banner_pc.lottie",
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "mAndBelow",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": "{assetsPath}/images/animated-banners/exclusive_arena_banner_mobile.lottie"
            }
          ]
        }
      },
      "title": "EXCLUSIVE",
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/888exclusive_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_888_EXCLUSIVE_GAMES",
        "infoText": "INFO_TEXT_ARENA_888_EXCLUSIVE_GAMES"
      },
      "promotionalBanner": {
        "bannerAdminPlaceholderId": "E3E237FC-9D1F-47B2-A0EC-82A498BE35AE"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "495172",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": "576025",
        "templateID": "392012"
      },
      "homepageHeader": {
        "title": "EXCLUSIVE",
        "image": "{assetsPath}/images/arenas/HomePage/888exclusive_arena.png",
        "link": "/exklusive-spiele/"
      },
      "advancedFilters": {
        "categories": [
          {
            "id": "gameGroups"
          },
          {
            "id": "features"
          },
          {
            "id": "themes"
          }
        ]
      }
    },
    "scratchCards": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/scratch_card_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/scratch_card_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/scratch_card_arena_banner_mobile.png"
          }
        ]
      },
      "animatedTopImage": {
        "url": {
          "defaultValue": "{assetsPath}/images/animated-banners/scratchcards_arena_banner_pc.lottie",
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "mAndBelow",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": "{assetsPath}/images/animated-banners/scratchcards_arena_banner_mobile.lottie"
            }
          ]
        }
      },
      "title": "INFO_TITLE_ARENA_SCRATCH_CARDS",
      "filters": [],
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/scratch_cards_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_SCRATCH_CARDS",
        "infoText": "INFO_TEXT_ARENA_SCRATCH_CARDS"
      },
      "promotionalBanner": {
        "display": false,
        "componentID": "577625",
        "templateID": "392012"
      },
      "linkToOffer": {
        "welcomeBonus": {
          "componentID": "497534",
          "templateID": "392012",
          "display": false
        }
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": {
          "defaultValue": "576027"
        },
        "templateID": {
          "defaultValue": "392012"
        }
      },
      "homepageHeader": {
        "title": "SCRATCH_CARDS",
        "image": "{assetsPath}/images/arenas/HomePage/scratch_cards_arena_icon.png",
        "link": "/rubbellose/"
      }
    },
    "newGames": {
      "topImage": {
        "defaultValue": "{assetsPath}/images/banners/new_games_arena_banner_pc.png",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "tool",
                "operator": "equal",
                "value": "tablet"
              }
            ],
            "value": "{assetsPath}/images/banners/new_games_arena_banner_tablet.png"
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "deviceType",
                "operator": "equal",
                "value": "mobile"
              }
            ],
            "value": "{assetsPath}/images/banners/new_games_arena_banner_mobile.png"
          }
        ]
      },
      "animatedTopImage": {
        "url": {
          "defaultValue": "{assetsPath}/images/animated-banners/newgames_arena_banner_pc.lottie",
          "statements": [
            {
              "condition": "AND",
              "rules": [
                {
                  "id": "mAndBelow",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": "{assetsPath}/images/animated-banners/newgames_arena_banner_mobile.lottie"
            }
          ]
        }
      },
      "title": {
        "defaultValue": "INFO_TITLE_ARENA_NEW_GAMES",
        "statements": []
      },
      "filters": [],
      "infoSideBar": {
        "infoImage": "{assetsPath}/images/arenas/HomePage/new_games_arena_info.png",
        "infoTitle": "INFO_TITLE_ARENA_NEW_GAMES",
        "infoText": "INFO_TEXT_ARENA_NEW_GAMES"
      },
      "promotionalBanner": {
        "display": true,
        "bannerAdminPlaceholderId": "E3658636-9EBA-4DD5-9B6C-BA996E63EB10"
      },
      "seoSection": {
        "display": {
          "defaultValue": true,
          "statements": [
            {
              "condition": "OR",
              "rules": [
                {
                  "id": "isEmbeddedHybrid",
                  "operator": "equal",
                  "value": true
                },
                {
                  "id": "IsAuthorized",
                  "operator": "equal",
                  "value": true
                }
              ],
              "value": false
            }
          ]
        },
        "componentID": "576022",
        "templateID": "392012"
      },
      "homepageHeader": {
        "title": "NEW_GAMES",
        "image": "{assetsPath}/images/arenas/HomePage/new_games_arena.png",
        "link": "/neue-slots/"
      }
    }
  },
  "homePage": {
    "topBanner": {
      "bannerAdminPlaceholderId": "B93A1FF9-CDEE-42F4-B1B7-FE4AD422CE77",
    },
    "headerArenasOrder": [
      "slots",
      "newGames",
      "exclusive888Games"
    ],
    "promotionalBanner": {
      "displayPlace": {
        "defaultValue": 4
      },
      "bannerAdminPlaceholderId": "708AB7AB-0303-424C-9678-172BC8DA0461"
    },
    "seoSection": {
      "display": {
        "defaultValue": true,
        "statements": [
          {
            "condition": "OR",
            "rules": [
              {
                "id": "isEmbeddedHybrid",
                "operator": "equal",
                "value": true
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": false
          }
        ]
      },
      "componentID": {
        "defaultValue": "575337"
      },
      "templateID": {
        "defaultValue": "392012"
      }
    }
  },
  "historyPage": {
    "topImage": {
      "defaultValue": "{assetsPath}/images/history_bg_title.png",
      "statements": []
    },
    "title": {
      "defaultValue": "GAMING_HISTORY",
      "statements": []
    }
  },
  "generalSettings": {
    "brandName": "888Slots",
    "assetsPath": "{assetsPath}",
    "logoAltOverride": "MR Green",
    "showBreadcrumbs": true,
    "googleOptimize": {
      "isEnabled": false
    },
    "logoURL": {
      "defaultValue": "{assetsPath}/images/mrgreenlogo.svg",
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 1
            }
          ],
          "value": "{assetsPath}/images/logos/reg-vip/vip-regular-logo.svg"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 2
            }
          ],
          "value": "{assetsPath}/images/logos/gold-vip/vip-gold-logo.svg"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 3
            }
          ],
          "value": "{assetsPath}/images/logos/diamond-vip/vip-diamond-logo.svg"
        },
        {
          "condition": "AND",
          "rules": [
            {
              "id": "statusGroupId",
              "operator": "equal",
              "value": 5
            }
          ],
          "value": "{assetsPath}/images/logos/platinum-vip/vip-platinum-logo.svg"
        }
      ]
    },
    "avatarUrl": {
      "drawer": {
        "defaultValue": {
          "regular": "{assetsPath}/images/user-menu-box-icon.png",
          "hover": "{assetsPath}/images/user-menu-box-icon.png",
          "pressed": "{assetsPath}/images/user-menu-box-icon.png"
        }
      },
      "sideMenu": {
        "defaultValue": {
          "regular": "{assetsPath}/images/avatars/reg/pre-login-reg.svg",
          "hover": "{assetsPath}/images/avatars/reg/pre-login-hover.svg",
          "pressed": "{assetsPath}/images/avatars/reg/pre-login-pressed.svg"
        },
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 1
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/reg-vip/pre-login-reg-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 2
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/gold-vip/pre-login-gold-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 3
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/diamond-vip/pre-login-diamond-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": false
              },
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 5
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/platinum-vip/pre-login-vip-platinum-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 0
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg/post-login-reg.svg",
              "hover": "{assetsPath}/images/avatars/reg/post-login-hover.svg",
              "pressed": "{assetsPath}/images/avatars/reg/post-login-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 1
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/reg-vip/post-login-reg-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 2
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/gold-vip/post-login-gold-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 3
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/diamond-vip/post-login-diamond-vip-avatar-pressed.svg"
            }
          },
          {
            "condition": "AND",
            "rules": [
              {
                "id": "statusGroupId",
                "operator": "equal",
                "value": 5
              },
              {
                "id": "IsAuthorized",
                "operator": "equal",
                "value": true
              }
            ],
            "value": {
              "regular": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-regular.svg",
              "hover": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-hover.svg",
              "pressed": "{assetsPath}/images/avatars/platinum-vip/post-login-vip-platinum-avatar-pressed.svg"
            }
          }
        ]
      }
    },
    "fallbackCMSComponentsPath": "{assetsPath}/fallbackCMSComponent/{fileName}.html",
    "gamesSettings": {
      "gamesPreviewDefaultImages": "{assetsPath}/games/preview_default_images/default_game_strip_{arena-category}.png",
      "gameBadgePath": "{assetsPath}/images/badges/",
      "homePageArenaDefaultPlaceHolder": "{assetsPath}/images/arenas/Homepage/default_arena.png",
      "liveArenaDefaultPlaceHolder": "{assetsPath}/images/arenas/LiveArenas/default_live_arena.png"
    },
    "gamesPreviewConfig": {
      "shouldDisplayJackpot": false,
      "disabledFeatures": [
        "hasJackpot"
      ]
    },
    "filters": {
      "exclusiveFilterBrandName": "Mr Green",
      "advancedFilters": {
        "preferredVendorFilters": [
          "vendor_playngo",
          "vendor_pragmatic",
          "vendor_888",
          "vendor_greentube",
          "vendor_gamomat",
          "vendor_merkur",
          "vendor_edict",
          "vendor_gamevy",
          "vendor_elk",
          "vendor_amatic",
          "vendor_blueprint",
          "vendor_redtiger",
          "vendor_netent",
          "vendor_gamesglobal",
          "vendor_playtech",
          "vendor_thunderkick",
          "vendor_yggdrasil",
          "vendor_lnw",
          "vendor_quickspin",
          "vendor_isoftbet",
          "vendor_inspired"
        ],
        "preferredThemeFilters": [
          "theme_egyptian",
          "theme_fish",
          "theme_fantasy_and_folklore",
          "theme_wildlife",
          "theme_classic_style",
          "theme_greek_mythology",
          "theme_adventure",
          "theme_diamonds_and_gems",
          "theme_arabic",
          "theme_comics_and_cartoons",
          "theme_fruit_and_candy",
          "theme_asian",
          "theme_ancient-civilization",
          "theme_irish",
          "theme_seasonal",
          "theme_space_and_sci-fi",
          "theme_money_and_leisure",
        ]
      }
    }
  },
  "safezone": {
    "enabled": false
  },
  "registrationOffer": {
    "display": {
      "defaultValue": false,
      "statements": [
        {
          "condition": "AND",
          "rules": [
            {
              "id": "IsAuthorized",
              "operator": "equal",
              "value": false
            }
          ],
          "value": true
        }
      ]
    },
    "componentID": "543323",
    "templateID": "392012"
  },
  "onboardingTour": {
    "enabledAccordingToRegistrationTime": false,
    "enabledAccordingToAB": true
  },
  "adminBanner": {
    "enabled": true
  },
  "SDK": {
    "WebPush": {
      "enabled": true,
      "prodSettings": {
        "defaultIcon": "https://c00120-dl.urbanairship.com/binary/public/E3ogv0QlTTGs9CYKYU7qHw/44f109ca-7c46-45fa-af6b-ffcacd1a611c",
        "defaultTitle": "Mr.Green_de",
        "defaultActionURL": "https://www.mrgreen.de",
        "appKey": "E3ogv0QlTTGs9CYKYU7qHw",
        "token": "MTpFM29ndjBRbFRUR3M5Q1lLWVU3cUh3OlVzTGw1eWtaS3RqTU1mb0s0TDRLdmF2N2F4NXJwT3ZHWFpHWGxIY0gxRWM",
        "vapidPublicKey": "BLMqwLsGtpz4dbCxzFNygZDDzLxOA1-aq-e2RgvrylnnGOxN0LaZC294xPPz5A0zs1jqZ39JN8i7DFwAklBzCsM="
      },
      "testSettings": {
        "defaultIcon": "https://c00120-dl.urbanairship.com/binary/public/wbBqjL6sTc2LFiGP475FEQ/163cc261-55ba-48e9-9786-2f6389fa2f3c",
        "defaultTitle": "Mr.Green_de",
        "defaultActionURL": "https://www.mrgreen.de",
        "appKey": "wbBqjL6sTc2LFiGP475FEQ",
        "token": "MTp3YkJxakw2c1RjMkxGaUdQNDc1RkVROktzWHVZbmc1ZWRhM1BBbTVxYm9Zdk5sY3c0RkdfUk53bHpzQ2JPX1JyUXc",
        "vapidPublicKey": "BBn4lEMpNMC0vwpefi0E61TVYiFGdtpoZs3DK-Ja-KHJdEfnQ813cD5smnB-ReUEHHdPxER6VtfiJFHqtWQBn5o="
      }
    },
    "NetEnt": {
      "staticServerUrlTemplate": {
        "defaultValue": "https://{casinoid}-staticde-test.casinomodule.com",
        "statements": [
          {
            "condition": "AND",
            "rules": [
              {
                "id": "env",
                "operator": "equal",
                "value": "prod"
              }
            ],
            "value": "https://{casinoid}-staticde.casinomodule.com"
          }
        ]
      }
    },
    "Filters": {
      "useAdvancedFilters": true
    }
  },
  "theme": {
    "name": "mrgreen"
  }
}